import React, {useState, useMemo, useEffect} from "react"
import {useStore} from "../Store"
//import {ChartPage, SettingsPage} from "./"
import {TrendRankingPage, SimilarChartPage, SettingsPage} from "./"   // ChartPage（旧ホームページ）を削除
import {redirectToDashboard} from "../common"
import * as am4core from "@amcharts/amcharts4/core"

export default function Switching() {
  const {
    store: {page},
  } = useStore()

  const [nextPage, setNextPage] = useState(null)

  const pages = {
    //HOME: useMemo(() => <ChartPage />, []),   // 「トレンドランキング」と「類似チャート」に画面分割
    TREND_RANKING: useMemo(() => <TrendRankingPage />, []),
    SIMILAR_CHART: useMemo(() => <SimilarChartPage />, []),
    SETTING: useMemo(() => <SettingsPage />, []),
  }

  useEffect(() => {
    if (page === `DASHBOARD`) redirectToDashboard().then()
    am4core.disposeAllCharts()
    if (page in pages) setNextPage(pages[page])
  }, [page])

  return useMemo(() => nextPage, [nextPage])
}
